// Ellipsoid volume formula, ported from source (getLastTumorVolumeRef,
// renderDrugAdminSection): volume(cm3) = length * width * depth * 0.524.
// 1 cm3 = 1 mL, no conversion needed for the drug-admin QC comparison.
export function tumorVolume(length: number, width: number, depth: number): number | null {
  if (!(length > 0) || !(width > 0) || !(depth > 0)) return null;
  const v = length * width * depth * 0.524;
  return Number.isFinite(v) && v > 0 ? v : null;
}

export type DrugAdminQcStatus = "ok" | "low" | "high" | "unknown";

export interface DrugAdminQc {
  status: DrugAdminQcStatus;
  tumorVolume: number | null;
  minML: number | null;
  maxML: number | null;
}

// Ported from renderDrugAdminSection (source line ~5730): injected volume must be
// within 10-15% of tumor volume. Advisory only, never a hard validation block.
export function computeDrugAdminQc(tumorVol: number | null, injectedVolume: number | null): DrugAdminQc {
  if (tumorVol === null) {
    return { status: "unknown", tumorVolume: null, minML: null, maxML: null };
  }
  const minML = tumorVol * 0.1;
  const maxML = tumorVol * 0.15;
  if (injectedVolume === null || !(injectedVolume > 0)) {
    return { status: "unknown", tumorVolume: tumorVol, minML, maxML };
  }
  if (injectedVolume < minML) return { status: "low", tumorVolume: tumorVol, minML, maxML };
  if (injectedVolume > maxML) return { status: "high", tumorVolume: tumorVol, minML, maxML };
  return { status: "ok", tumorVolume: tumorVol, minML, maxML };
}
